import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';

import { batchRequest } from '../../../../../api/ApiService';

import SkillsChart from '../../../../../components/peer-feedback/components/skills-chart';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../../components/ui';


import SelectorWrapper from '../../components/selector-wrapper';

class TeamworkSkills extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedUserId: 0,
      chartData: [],
      defaultChartData: [],
      loaded: false,
    };
  }

  componentDidMount() {
    const { finishedSurveys } = this.props;
    const requestUrls = finishedSurveys.map(finishedSurvey => `${process.env.REACT_APP_API_URL}v2/forms/skills-assessment/${finishedSurvey.id}/instructor`);
    this.generateChartData(requestUrls, true);
  }

  generateChartData = (requestUrls, setDefaultChartData, multiplier = 1) => {
    const { finishedSurveys } = this.props;

    batchRequest(
      requestUrls
    ).then(res => {
      let chartData = [];
      let showData = {
        second: false,
        final: false
      };

      res.forEach((scoreValueResponse, index) => {
        const currentSurvey = finishedSurveys[index];
        const scoreValueResult = scoreValueResponse.body;
        if (currentSurvey.stage === 'initial') {
          if (scoreValueResult) {
            Object.keys(scoreValueResult).forEach(userScoreQuestion => {
              if (userScoreQuestion !== 'Not Applicable') {
                chartData.push({
                  question: userScoreQuestion,
                  initial: scoreValueResult[userScoreQuestion] * multiplier
                });
              }
            });
          }
        }
        else if (scoreValueResult) {
          Object.keys(scoreValueResult).forEach(userScoreQuestion => {
            const currentQuestion = chartData.find(chartItem => chartItem.question === userScoreQuestion);
            if (currentQuestion) {
              chartData.find(chartItem => chartItem.question === userScoreQuestion)[currentSurvey.stage] = scoreValueResult[userScoreQuestion] * multiplier;
            } else {
              if (userScoreQuestion !== 'Not Applicable') {
                chartData.push({
                  question: userScoreQuestion,
                  [currentSurvey.stage]: scoreValueResult[userScoreQuestion] * multiplier
                });
              }
            }

            showData[currentSurvey.stage] = true;
          });
        }
      });

      this.setState({
        loaded: true,
        chartData,
        showData
      });
      if (setDefaultChartData) {
        this.setState({
          defaultChartData: chartData
        });
      }
    })
      .catch(err => { console.log(err); });
  }

  get teamPlayersOptions() {
    const { gamesTeamplayers } = this.props;
    let options = gamesTeamplayers.map(gamesTeamplayer => (
      {
        id: gamesTeamplayer.user.id,
        name: `${gamesTeamplayer.user.first_name} ${gamesTeamplayer.user.last_name}`
      }
    ));
    const sortedOptions = [...options].sort((a, b) => a.name.localeCompare(b.name));

    sortedOptions.unshift({ id: 0, name: 'Overall' });
    return sortedOptions;
  }

  handleSelectChange = (value) => {
    const { finishedSurveys } = this.props;
    const { defaultChartData } = this.state;

    if (value === 0) {
      this.setState({
        selectedUserId: value,
        chartData: defaultChartData,
        loaded: true
      });
    } else {
      this.setState({
        loaded: false,
        selectedUserId: value,
      });

      const requestUrls = finishedSurveys.map(finishedSurvey => `${process.env.REACT_APP_API_URL}v2/forms/skills-assessment/${finishedSurvey.id}/student/${value}/`);
      this.generateChartData(requestUrls, false, 5);
    }
  }

  render() {
    const {
      selectedUserId,
      loaded,
      chartData,
      showData
    } = this.state;

    const options = this.teamPlayersOptions;

    return (
      <Wrapper>
        <PreTitle>Skills Assessment</PreTitle>
        <Title>Teamwork Skills</Title>
        <Text>The Skills Map below is a visual indicator of the behaviors/skills that your students are demonstrating. The wider the filled area, the greater the number of teammates that are in agreement.</Text>
        <SelectorWrapper
          label={'View'}
          options={options}
          onSelectorChange={this.handleSelectChange}
          selectedOptionId={selectedUserId}
        />
        {
          !loaded &&
          <Loader type="ball-scale-ripple" active />
        }
        {
          loaded &&
          <SkillsChart
            title='Skills Map'
            data={chartData}
            showData={showData}
          />
        }
      </Wrapper >
    );
  }

}

export default TeamworkSkills;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/skills-assessment/teamwork-skills.js